import { render } from "./EditCategoriesConfirmPopup.vue?vue&type=template&id=5e27a07d"
import script from "./EditCategoriesConfirmPopup.vue?vue&type=script&lang=js"
export * from "./EditCategoriesConfirmPopup.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/nahodka.xpage.dev/htdocs/public/local/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__